import { BaseApiSelector } from "@bornfight/aardvark";
import { ResourceType } from "enums/ResourceType";
import { AdministratorJSONAModel } from "interfaces/jsona-models/AdministratorJSONAModel";

export class AdministratorSelector extends BaseApiSelector<AdministratorJSONAModel> {
  constructor() {
    super(ResourceType.Administrator);
  }
}
